import React, { ReactNode } from 'react';
import { useModularity, ModuleName } from 'shared/hooks/useModularity';

interface IHasModuleProps {
  children: ReactNode;
  moduleToCheck: ModuleName;
}
interface IHasModulesProps {
  children: ReactNode;
  modulesToCheck: ModuleName[];
}

const HasModule = ({ moduleToCheck, children }: IHasModuleProps): JSX.Element | null => {
  // Get the modules from the useModules hook
  const { modules } = useModularity();
  // Check if the ottoModuleToCheck is enabled
  if (modules.includes(moduleToCheck)) return <>{children}</>;
  // If the module is not enabled, return null
  return null;
};

export const HasModules = ({ modulesToCheck, children }: IHasModulesProps): JSX.Element | null => {
  // Get the modules from the useModules hook
  const { modules } = useModularity();
  // Check if any of the modulesToCheck are enabled
  // If any of the modules are enabled, return the children
  if (modulesToCheck.some((module) => modules.includes(module))) {
    return <>{children}</>;
  }
  // If no modules are enabled, return null
  return null;
};

export default HasModule;
